import { useState } from "react";

import { getClimateAlertNames, getWarningNames } from "../../utils/alertUtils";
import { renderSideLine, renderTags } from "../../utils/utils";
import DropDownMenu from "../common/DropDownMenu";
import { IUnitDetailsDataHome } from "../../interfaces/interfaces";
import { ReactComponent as Key } from "../../img/key.svg";
import { ReactComponent as More } from "../../img/header/More.svg";
import { renderUnitDetailsElementAmount } from "../unitDetails/common/CommonUnitDetailsComponents";

export interface HomeDetailsMainInfoForLargeScreenProps {
  home: IUnitDetailsDataHome;
  numBrilliantDevices: number;
  numIntegrations: number;
  openRemoveHomeModal: () => void;
}

const HomeDetailsMainInfoForLargeScreen: React.FC<
  HomeDetailsMainInfoForLargeScreenProps
> = ({ home, numBrilliantDevices, numIntegrations, openRemoveHomeModal }) => {
  const [dropDownMenuVisible, setDropDownMenuVisible] = useState(false);
  const alertDetected = home.alerts.length !== 0;
  const alerts = getClimateAlertNames(home.alerts);
  const warningNames = getWarningNames(home.warnings);
  const hasWarnings = warningNames.length > 0;
  return (
    <div className="unit-main-container unit-main-container-pro-view">
      {renderSideLine({
        hasAlerts: alertDetected,
        hasWarnings,
        lineClassName: "unit-main-container-line",
      })}

      <div className="flex-display">
        <div className="unit-names">
          <Key title="Key" className="unit-names-img" />
          <div className="unit-names-info unit-names-info-pro-view">
            <div className="unit-names-info-name unit-title">
              {home.propertyName}
            </div>
            {renderTags({ alerts, warnings: warningNames })}
          </div>
        </div>
        <div className="unit-details-container-right">
          <div className="unit-details-container unit-description-small unit-description-small-info">
            <div className="unit-details">
              {renderUnitDetailsElementAmount({
                nameOfSingleDevice: "Brilliant",
                numDevices: numBrilliantDevices,
              })}
            </div>
            <div className="unit-details">
              {renderUnitDetailsElementAmount({
                nameOfSingleDevice: "Integration",
                numDevices: numIntegrations,
              })}
            </div>
          </div>
          <div className="dashboard-settings-more">
            {dropDownMenuVisible && (
              <DropDownMenu>
                <button
                  className="dashboard-settings-more-btn unit-description-small"
                  type="button"
                  onClick={() => {
                    openRemoveHomeModal();
                    setDropDownMenuVisible(false);
                  }}
                >
                  Remove From ProView
                </button>
              </DropDownMenu>
            )}
            <More
              className="dashboard-settings-more-svg"
              onClick={() => setDropDownMenuVisible(!dropDownMenuVisible)}
              title="More Button"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeDetailsMainInfoForLargeScreen;
